import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fp_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    const { photo, face_photo, face_embedding, ...slim } = data.user || {};
    localStorage.setItem("fp_token", data.token);
    try { localStorage.setItem("fp_user", JSON.stringify(slim)); } catch { /* armazenamento cheio: segue só com o token */ }
    setUser(slim);
    return slim;
  };

  const logout = () => {
    localStorage.removeItem("fp_token");
    localStorage.removeItem("fp_user");
    setUser(null);
  };

  const can = (roles) => {
    if (!user) return false;
    if (user.role === "admin") return true;
    return roles.includes(user.role);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, loading, can }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
